<template>
  <!-- Footer -->
  <footer class=" pt-md-3 pb-4">
    <div class="col-12 d-flex justify-content-center align-items-center flex-column">
      <img :src="'https://'+estilo.footer.identidad.logo" width="40" height="40" alt="">
      <a :href="estilo.footer.identidad.url_site" target="_blank" class="page-link"
         :style="'color:'+estilo.footer.identidad.color">
        {{estilo.footer.identidad.url_site.substring(estilo.footer.identidad.url_site.indexOf('://')+3,estilo.footer.identidad.url_site.length)}} </a>
    </div>
    <div class="row mx-auto pt-3 pt-md-3 border-top pb-4"
         :style="{'background-color': estilo.footer.fondo.background_color}">
      <div class="col-12 d-flex justify-content-around   pb-3">
        <a :href="estilo.footer.enlaces.enlace1.url" target="_blank" class="ml-5"
           :style="{color:estilo.footer.texto.color, 'font-size':estilo.footer.texto.font_size+'px'}">
          {{ estilo.footer.enlaces.enlace1.nombre}}
        </a>
        <a :href="estilo.footer.enlaces.enlace2.url" target="_blank" class="mr-5"
           :style="{color:estilo.footer.texto.color, 'font-size':estilo.footer.texto.font_size+'px'}">
          {{ estilo.footer.enlaces.enlace2.nombre}}
        </a>
      </div>

      <div id="" class="small font-weight-bold col-12 text-center"
           :style="{'color':'#ffffff', 'font-size': '12px'}">
        &copy;2018 {{estilo.footer.copyrigth.text}} Etaxi group AG. (España - Suiza)
      </div>
    </div>
  </footer>
  <!-- ./Footer -->
</template>

<script>

  import estilosFomateadorJson from "../../compartida/estilosFomateadorJson";
  import servicioApi from "./../../privada/servicioApi";

  export default {
    name: "footerPublic",
    data() {
      return {
        estilo: {
          footer: {
            fondo: {background_color: ""},
            identidad: {url_site: '#', logo: '', color: ''},
            texto: {color: "", font_size: ""},
            enlaces: {enlace1: {nombre: "", url: "#"}, enlace2: {nombre: "", url: "#"}},
            copyrigth: {text: ''}
          },
          cabecera: {
            barraNavegacion: {
              nombre: {color: '', font_size: ''},
              idioma: {color: '', font_size: ''}
            }
          },
          paginaInicio: {
            cabecera: {color: '', font_size: ''},
            grupoCategorias: {font_size: '', color: ''},
          },
          unaCategoria: {
            menuUbicacion: {font_size: '', color: ''},
            tituloPrincipal: {color: '', font_size: ''},
            tituloSecundario: {color: '', font_size: ''}
          }
        }
      }
    },
    created() {
      this.cargarEstilos();
    },
    methods: {
      cargarEstilos: function () {
        let cliente = this.$route.params.cliente;
        servicioApi.rol_regular.estilos.get(cliente).then(resp => {

          let data = resp.data.data;
          Object.keys(data).filter(index => {

            // console.log('unaCategoria', data[index])
            if (data[index].nombre == 'unaCategoria') {
              // console.log(80,'data[index].estilo unaCategoria', JSON.parse(data[index].estilo));
              EventBus.$emit('unaCategoria', JSON.parse(data[index].estilo))

            } else if (data[index].nombre == 'paginaInicio') {
              // console.log(84, 'data[index].estilo paginaInicio', JSON.parse(data[index].estilo));
              EventBus.$emit('paginaInicio', JSON.parse(data[index].estilo));

            } else if (data[index].nombre == 'cabecera') {
              // console.log(88, 'data[index].estilo barraNavegacion', JSON.parse(data[index].estilo));
              EventBus.$emit('barraNavegacion', JSON.parse(data[index].estilo));

            } else if (data[index].nombre == 'footer') {
              // console.log(93,'data[index].estilo footer', JSON.parse(data[index].estilo));
              let footer = JSON.parse(data[index].estilo);

              this.estilo.footer.fondo.background_color = footer.fondo['background-color'];
              this.estilo.footer.texto.color = footer.texto.color;
              this.estilo.footer.texto.font_size = footer.texto['font-size'];
              this.estilo.footer.enlaces = footer.enlaces;
              this.estilo.footer.identidad = footer.identidad;
              this.estilo.footer.copyrigth.text = footer.copyrigth.text;

            }
          });
        }).catch(e => {
        });
      }
    }
  }
</script>

<style scoped>
  .footer {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/publico/share/footer.vue